import { Phone, ClipboardCheck, Rocket } from "lucide-react";

const STEPS = [
    {
        num: "01",
        icon: Phone,
        title: "Discovery Call",
        window: "Within 24 hours",
        body: "A senior lead strategist calls you to understand your project, city, target buyer profile and lead volumes.",
    },
    {
        num: "02",
        icon: ClipboardCheck,
        title: "Custom Proposal",
        window: "Within 48–72 hours",
        body: "You receive a written proposal with channel plan and expected CPL, tailored to your project.",
    },
    {
        num: "03",
        icon: Rocket,
        title: "Campaign Kickoff",
        window: "Within 7 days",
        body: "Creatives approved, CRM integrated, campaigns live — with the first verified leads landing in your inbox by day 8.",
    },
];

export default function OnboardingSteps() {
    return (
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 pt-24 sm:pt-32">
            <div className="mb-12">
                <div className="flex items-center gap-3 mb-4">
                    <div className="h-px w-10 bg-[#D4AF37]" />
                    <span className="overline">What Happens After You Enquire</span>
                </div>
                <h2 className="font-serif-display text-3xl sm:text-4xl leading-tight tracking-tight">
                    Three simple steps between <span className="italic text-[#D4AF37]">now and your first lead</span>.
                </h2>
            </div>

            <div className="grid md:grid-cols-3 gap-4 relative" data-testid="onboarding-steps">
                {/* Gold connector line on desktop */}
                <div className="hidden md:block absolute top-9 left-[16.66%] right-[16.66%] h-px bg-gradient-to-r from-[#D4AF37]/40 via-[#D4AF37] to-[#D4AF37]/40 z-0" />

                {STEPS.map((s) => (
                    <div
                        key={s.num}
                        data-testid={`onboarding-${s.num}`}
                        className="relative z-10 bg-[#050507] pt-6"
                    >
                        <div className="flex items-center gap-4 mb-6">
                            <div className="h-14 w-14 shrink-0 bg-[#D4AF37] text-black grid place-items-center shadow-[0_0_30px_rgba(212,175,55,0.3)]">
                                <s.icon size={22} strokeWidth={1.5} />
                            </div>
                            <div className="font-serif-display text-5xl text-[#D4AF37]/30 leading-none">
                                {s.num}
                            </div>
                        </div>
                        <h3 className="font-serif-display text-2xl leading-tight">{s.title}</h3>
                        <div className="mt-1 text-xs text-[#D4AF37] uppercase tracking-widest">{s.window}</div>
                        <p className="mt-3 text-sm text-white/60 leading-relaxed">{s.body}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
